import { formatCurrency } from "@/utils/numberUtils";
import { EMPTY_DISPLAY_VALUE } from '@shared/constants/display';

const VALUE_FORMATTERS = {
  boolean: (val) => (val ? 'Sí' : 'No'),
  currency: (val) => formatCurrency(val),
  integer: (val) => String(val),
  decimal: (val) => new Intl.NumberFormat('es-CO').format(Number(val)),
  date: (val) => new Date(val).toLocaleDateString('es-CO'),
  string: (val) => String(val),
  select: (val) => String(val),
};

export const formatRuleValue = (value, valueType) => {
  if (value == null) return EMPTY_DISPLAY_VALUE;

  const formatter = VALUE_FORMATTERS[valueType] || VALUE_FORMATTERS.string;

  if (Array.isArray(value)) {
    return value.map(formatter).join(', ');
  }

  return formatter(value);
};
